import { darkTheme } from '@sparemin/blockhead';

export const blockheadTheme = {
  ...darkTheme,
  spacing: {
    ...darkTheme.spacing,
    dialogOffset: 40,
  },
};
